import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { PageEvent } from '@angular/material/paginator';
import { ShortenedWarranty } from 'src/app/models/shortened-warranty.model';


import { GuarantiesService } from 'src/app/services/guaranties.service';
import { UtilsService } from 'src/app/services/utils.service';
import { ErrorResponse } from 'src/app/models/error.model';
import { DataTableColumn, PaginatorStatus, SortConfiguration } from 'src/app/components/generics/data-table/data-table.component';
import { CustomTableFilter } from 'src/app/components/generics/table-filter/table-filter.component';

@Component({
  selector: 'app-warranty-selector-dialog',
  templateUrl: './warranty-selector-dialog.component.html',
  styleUrls: ['./warranty-selector-dialog.component.scss']
})
export class WarrantySelectorDialogComponent implements OnInit {

  @ViewChild('buttonsColumnTemplate', { static: true })
  buttonsColumnTemplate: TemplateRef<any>;

  guaranties: ShortenedWarranty[];

  paginatorStatus: PaginatorStatus = {
    itemsPerPage: 10,
    page: 0,
    totalElementCount: 0
  };

  columns: DataTableColumn[] = [
    { name: 'ID', prop: 'id', sortable: true },
    { name: 'Alquiler', prop: 'cotizacionAlquiler', type: 'money' },
    { name: 'Expensas', prop: 'cotizacionExpensas', type: 'money' },
    { name: 'Agente', parseValue: (w: ShortenedWarranty) => w.agenteNombre + ' ' + w.agenteApellido },
    { name: 'Inquilino', prop: 'emailInquilinoPrincipal', type: 'email' },
    { name: 'Estado', prop: 'estado', sortable: true, type: 'text' },
    { name: 'Propiedad', prop: 'propiedadDireccion', type: 'resumed-address', minWidth: '160px' },
    { name: '', width: '120px', minWidth: '120px' } // columna de botón seleccionar
  ];

  sortConfiguration?: SortConfiguration;

  filters: CustomTableFilter[] = [
    { key: 'id', description: 'ID', type: 'NUMBER' },
    { key: 'estado', description: 'Estado', type: 'ENUM', availableOptions: [
        { codigo: 'DOCUMENTACION', descripcion: 'DOCUMENTACION' },
        { codigo: 'PAGO_PENDIENTE', descripcion: 'PAGO PENDIENTE' },
        { codigo: 'GENERAR_CONTRATO', descripcion: 'GENERAR CONTRATO' },
        { codigo: 'AUTORIZACION_PENDIENTE', descripcion: 'AUTORIZACION PENDIENTE' },
        { codigo: 'FIRMA_DIGITAL', descripcion: 'FIRMA DIGITAL' },
        { codigo: 'FIRMA_PENDIENTE', descripcion: 'FIRMA PENDIENTE' },
        { codigo: 'ACTIVA', descripcion: 'ACTIVA' },
        { codigo: 'FINALIZADA', descripcion: 'FINALIZADA' },
        { codigo: 'BAJA_ANTICIPADA', descripcion: 'BAJA ANTICIPADA' },
        { codigo: 'BAJA_POR_ADMIN', descripcion: 'BAJA POR ADMIN' },
        { codigo: 'BAJA_POR_AGENTE', descripcion: 'BAJA POR AGENTE' },
    ] },
    { key: 'propiedad-codigo', description: 'Código de propiedad', type: 'STRING' },
    { key: 'propiedad-direccion', description: 'Dirección', type: 'STRING' }
  ];

  filterValues: any = {};

  constructor(
    private guarantiesService: GuarantiesService,
    private utilsService: UtilsService,
    private dialogRef: MatDialogRef<WarrantySelectorDialogComponent>
  ) {}

  ngOnInit(): void {
    this.columns.find(c => c.name === '').template = this.buttonsColumnTemplate;
    this.getGuaranties();
  }

  getGuaranties() {
    this.guarantiesService.getGuarantees(
      this.paginatorStatus.page,
      this.paginatorStatus.itemsPerPage,
      this.sortConfiguration ? [this.sortConfiguration] : [],
      this.filterValues
    ).subscribe(response => {
      this.paginatorStatus.totalElementCount = parseInt(response.headers.get('pagination-total-count') ?? '0', 10);
      this.guaranties = response.body;
    }, (error: ErrorResponse) => {
      this.utilsService.alert('Error al obtener garantías', error.error?.descripcion);
    });
  }

  updateGuaranties(event: PageEvent) {
    this.paginatorStatus.itemsPerPage = event.pageSize;
    this.paginatorStatus.page = event.pageIndex;
    this.getGuaranties();
  }

  updateSort(event: SortConfiguration) {
    this.sortConfiguration = event;
    this.getGuaranties();
  }

  setFilterValues(values: any) {
    this.filterValues = values;
    this.getGuaranties();
  }

  selectWarranty(warranty: ShortenedWarranty) {
    this.dialogRef.close(warranty);
  }
}
